import { createContext } from "react"

const MinAndStandardLabelContext = createContext<{
  minId?: string
  standardId?: string
}>(null as any)

export default MinAndStandardLabelContext
